export class Status {
    constructor(private _statusCode: number, private _occurrence: number) { }

    set StatusCode(statusCode: number) { this._statusCode = statusCode }
    get StatusCode(): number { return this._statusCode }

    set Occurrence(occurrence: number) { this._occurrence = occurrence }
    get Occurrence(): number { return this._occurrence }
}